/** The bank's name and the rail's round label as last read: while a page or a round loads again the header keeps them instead of falling back to the product name and an empty label. */
const known: { bank: string | null; round: string | null } = { bank: null, round: null };

export const rememberBank = (name: string | undefined): string | null => { if (name !== undefined) known.bank = name; return known.bank; };
export const rememberRound = (label: string | null): string | null => { if (label !== null) known.round = label; return known.round; };
